// Client for the BYOM chat endpoint (/api/chat-custom). Sends the Supabase
// JWT; the server verifies it and enforces plan limits.
import { supabase } from '../lib/supabaseClient';

export const LANGUAGE_OPTIONS = [
  { value: '', label: 'Auto' },
  { value: 'English', label: 'English' },
  { value: 'Greek', label: 'Greek' },
  { value: 'Filipino', label: 'Filipino' },
  { value: 'Hindi', label: 'Hindi' },
];

export class ChatLimitError extends Error {
  constructor(message, remaining) {
    super(message);
    this.name = 'ChatLimitError';
    this.limitReached = true;
    this.remaining = remaining;
  }
}

// messages: [{role:'user'|'assistant', content}], language: '' | override name
// modelOverride: admin-only testing override (the server verifies is_admin
// and silently ignores the param for everyone else).
export async function sendChatMessage({ messages, equipmentPath, language, modelOverride }) {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) throw new Error('Please log in to use the chat.');

  const res = await fetch('/api/chat-custom', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      // The UI keeps rich message objects (queryLogId for feedback, etc.) —
      // the API payload carries ONLY {role, content}. Anything extra would
      // reach the Anthropic Messages API and get the whole call rejected
      // with 400 "Extra inputs are not permitted".
      messages: messages.map(m => ({ role: m.role, content: m.content })),
      equipment_path: equipmentPath,
      language: language || undefined,
      model_override: modelOverride || undefined,
    }),
  });

  let json = null;
  try {
    json = await res.json();
  } catch {
    // non-JSON body — handled by the generic error below
  }
  if (res.status === 402) {
    throw new ChatLimitError(json?.error || 'Message limit reached.', json?.remaining);
  }
  if (!res.ok) {
    throw new Error(json?.error || `Request failed (${res.status})`);
  }
  return json; // { answer, query_log_id, model_used, mode, remaining, context_used }
}
